import React from "react";
import { Link } from "react-router-dom";
import { categories, products } from "../data/salonsData";

function Salons() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Salons</h1>
      {categories.map((cat) => (
        <section key={cat.id} id={cat.id}>
          <h2 className="text-xl font-semibold mb-4">{cat.label}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {products[cat.id].map((prod) => (
              <Link
                key={prod.id}
                to={`/product/${prod.id}`}
                state={prod}
                className="bg-white shadow-md rounded-2xl overflow-hidden hover:shadow-lg transition cursor-pointer"
              >
                <img src={prod.image} alt={prod.name} className="w-full h-40 object-cover"/>
                <div className="p-4">
                  <h3 className="text-lg font-semibold">{prod.name}</h3>
                </div>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export default Salons;